import React from "react";
import "../styleInvoice.css";
import imagenLogo from "../images/logo-20h23F.png";
import { useLocation } from "react-router-dom";
import { useState } from 'react';


export const DetailsPage = (props) => {
    return (
        <div className="invoice-wrapper" id="print-area">
            <div className="invoice">
                <div className="invoice-container">
                    <div className="invoice-head">
                        <div className="invoice-head-top">
                            <div className="invoice-head-top-left text-start">
                                <img src={imagenLogo} />
                            </div>
                            <div className="invoice-head-top-right text-end">
                                <h3>Asistente de creación paso a paso:</h3>
                            </div>
                        </div>
                        <div className="hr"></div>
                        <div className="hr"></div>
                        <p> <li className='text-bold'>Pública y comienza a cautivar a las empresas con tus "Paquetes Corporativos". <br /> Sigue el instructivo: <br /><br />  </li>
                            * Título: de la gastro-experiencia. Máximo de 33 caracteres.<br /><br />
                            ✔ Ciudad:  Seleccionar     <br /><br />
                            ✔ Clase: Seleccionar        <br /> <br />
                            ✔ Modalidad:  Seleccionar      <br />         <br />
                            ✔ Dirección:  (en caso de ser categoria presencial) <br /> <br />
                            * Anfitrión: Nombre; Restaurante/ Chef / Sumiller / Barista /etc. (Máximo 47 Caracteres).     <br />        <br />
                            *  Descripción: Texto corto, elegante y bien redactado. (Máximo de 495 caracteres).<br /><br />
                            ✔ Capacidad: Capacidad mínima y máxima<br /><br />
                            ✔ Fecha y hora: (dias y horas disponibles o Sujeto a disponibilidad)<br /><br />
                            ✔ Duración: Tiempo de la actividad en el siguiente formato (2 h 30 min). <br /><br />
                            ✔ Valor: Se paga "fee" por venta exitosa (con base en el valor de la “experiencia” publicada) <br /><br />
                            *    $10.000 si el precio del producto o servicio x persona es menor a $100.000                 <br /><br />
                            *    10% si el precio del producto o servicio x persona es superior a  $100.000       <br />
                            Nuestro mercado es corporativo, publica tarifas especiales x persona con el "fee" incluido.                    <br />
                            (Estos precios se podrán actualizar cada 3 meses o cada vez que se requiera.) <br /><br />
                            ✔ Incluye: Ejemplos: Experto gastronómico, barista, sumiller, etc.    <br />
                            Sí es online, Kit para 1 o 2 personas, lista de contenido. Producción, luces y sonido. Opcional incluir envío.<br />
                            Sí es presencial, Detalle del Menú + bebidas. (sala privada, equipamiento, parqueaderos.)<br />
                            Finalizar cada item con un "punto" (“.”) de esta forma se mostrará en formato “lista”<br /><br />
                            ✔ 3 fotos (formato cuadrado) (HD alta resolución) 1a. foto portada y 2a. y 3a. fotos interiores.(ambiente, experiencia y/o producto).<br />
                            NOTA: *Tener en cuenta límite de caracteres en algunos campos.<br /><br />
                            ✔ Verificación: Se realizará una reunión previa con el futuro aliado. <br />
                            Una vez que el aliado haya completado el formulario de publicacion con el detalle de la <br />
                            experiencia o paquete corporativo, MENUMARKET realizará una revisión de textos e <br />
                            imagenes y comprobara que la calidad de la informacio refleje el concepto de la plataforma <br />
                            en caso contrario se haran las debidas correcciones con el conocimiento del proveedor.<br /><br />


                            <hr />
                            Cualquier duda escríbeme: atencionalcliente@menumarket.co

                            <hr />
                            ¡FELICIDADES, ya haces parte del nuevo y único modelo de búsqueda de Gastro-Experiencias
                            Corporativas! La 1a vitrina diseñada para las empresas.

                        </p>
                    </div>
                </div>
            </div>
        </div>);
};